import ApiEndpointConstants, {
  LIST_URL,
} from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_dontion_list = (page, per_page, country) => {
  return api.get(`${LIST_URL}${ApiEndpointConstants.GETDONTIONLIST}`, {
    params: {
      page,
      per_page, 
      country
    }
  });
};
